import type { ReactNode } from 'react'

/** Props for SkipLink component */
interface SkipLinkProps {
  targetId?: string
  children?: ReactNode
}

/**
 * Skip Navigation Link for Accessibility
 * Allows keyboard users to skip to main content
 */
function SkipLink({
  targetId = 'main-content',
  children = 'Skip to main content'
}: SkipLinkProps): JSX.Element {
  return (
    <a
      href={`#${targetId}`}
      className="skip-link"
    >
      {children}
    </a>
  )
}

export default SkipLink
